import { bloomreachLib } from '../bloomreach';
import { BloomreachEventName } from './config';
import type { PayButtonClickParams } from '../analytics';

export const payButtonClick = (params: PayButtonClickParams) => {
  bloomreachLib.track(BloomreachEventName.PAYMENT_CLICK, {
    payment_provider: 'freedom',
    available_payment_providers: ['freedom'],
    price: Number(params.bill.amount),
    is_cashback_applied: false,
    is_promocode_applied: Boolean(params.promocodeModifier),
  });
};
